import { GridItem, type GridItemProps } from '@chakra-ui/react';

export type UiGridItemProps = GridItemProps;

export const UiGridItem = GridItem;
